<template>
  <div class="menu">
    <span class="button-menu-back sprite-return" @click="$emit('backMenu')"/>
    <button-menu
      :label="dictionnary ? dictionnary.formeMenu.carre : ''"
      iconClass="sprite-shape-square"
      @click.native="createShape('square')"
    />
    <button-menu
      :label="dictionnary ? dictionnary.formeMenu.rectangle : ''"
      iconClass="sprite-shape-rectangle"
      @click.native="createShape('rectangle')"
    />
    <button-menu
      :label="dictionnary ? dictionnary.formeMenu.rond : ''"
      iconClass="sprite-shape-round"
      @click.native="createShape('circle')"
    />
    <button-menu
      :label="dictionnary ? dictionnary.formeMenu.triangle : ''"
      iconClass="sprite-shape-triangle"
      @click.native="createShape('triangle')"
    />
    <span class="separator"/>
    <button-menu
      :label="dictionnary ? dictionnary.textMenu.couleur : ''"
      iconClass="sprite-color"
      @click.native="openColor=true"
    />
    <span class="separator"/>
    <button-menu
      :label="dictionnary ? dictionnary.textMenu.dropshadow : ''"
      iconClass="sprite-shadow"
      @click.native="createShadow"
      ref="buttonShadow"
    />
    <transition name="fade">
      <slider-drop-shadow :editor="editor" v-show="openShadow" ref="shadow"/>
    </transition>
    <color-modal :open="openColor" @close="openColor=false" @changeColor="updateColor"/>
  </div>
</template>
<script>
import menu from './menu-default'

import ButtonMenu from '@/components/buttons/ButtonMenu'
import ColorModal from '@/components/modal/ColorModal'
import SliderDropShadow from '@/components/slider/SliderDropShadow'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FormesMenu',
  mixins: [menu],
  components: {
    ButtonMenu,
    ColorModal,
    SliderDropShadow
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      openColor: false,
      openShadow: false
    }
  },
  props: {},
  computed: {
    ...mapGetters(['getCurrentColor'])
  },
  methods: {
    updateColor(color) {
      if (this.editor.getCurrentSelectedObject()) {
        this.editor.setColor(color)
        this.templateModified()
      }
    },
    createShape(shape) {
      this.editor.insertShape(shape, this.getCurrentColor)
      this.templateModified()
    },
    createShadow() {
      this.openShadow = !this.openShadow
      if (this.openShadow) {
        const x = this.$refs.buttonShadow.$el.offsetLeft + this.$refs.buttonShadow.$el.clientWidth / 2 - 282 / 2
        this.$refs.shadow.$el.style.left = x + 'px'
        this.$refs.buttonShadow.$el.classList.add('button-menu-selected')
      } else {
        this.$refs.buttonShadow.$el.classList.remove('button-menu-selected')
      }
    }
  },
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/menu/FormesMenu.vue